export default __webpack_public_path__ + "static/media/popcorn-pieces-07.9ba3ff55.png";